var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.281,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 170.48
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.24,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 170.48
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170.76,
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 170.48
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M163.883,375.426c-3.66-2.102-89.698-52.145-89.698-129.064V141.227h185.533v105.135  c0,76.919-86.038,126.962-89.698,129.064l-3.068,1.751L163.883,375.426z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "215.543,227.809 186.388,231.649 176.669,231.649 176.669,214.25 182.499,214.25   205.824,218.091 202.665,204.531 205.824,190.974 182.499,194.813 176.669,194.813 176.669,188.936 180.509,159.781   166.951,163.729 153.392,159.781 157.232,188.936 157.232,194.813 151.4,194.813 128.077,190.974 131.235,204.531 128.077,218.091   151.4,214.25 157.232,214.25 157.232,231.649 147.514,231.649 118.359,227.809 122.307,241.368 118.359,254.926 147.514,251.086   157.232,251.086 157.232,295.838 176.669,295.838 176.669,251.086 186.388,251.086 215.543,254.926 211.595,241.368 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M166.951,277.285c-12.775,0-23.733,7.75-28.447,18.802c-0.83-0.068-1.627-0.249-2.475-0.249  c-16.465,0-29.797,12.905-30.742,29.131c25.046,30.832,56.416,49.204,58.596,50.457l3.068,1.751l3.068-1.751  c2.18-1.253,33.55-19.625,58.596-50.457c-0.944-16.227-14.277-29.131-30.742-29.131c-0.848,0-1.644,0.181-2.475,0.249  C190.684,285.035,179.726,277.285,166.951,277.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M253.533,147.412c0,0,0,74.213,0,98.951c0,74.213-86.582,123.688-86.582,123.688  s-86.582-49.475-86.582-123.688c0-24.738,0-98.951,0-98.951L253.533,147.412 M265.902,135.043h-12.369H80.369H68v12.369v98.951  c0,80.465,89.025,132.262,92.814,134.428l6.137,3.506l6.137-3.506c3.789-2.167,92.814-53.963,92.814-134.428v-98.951  L265.902,135.043L265.902,135.043z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/SK.c5fcbb1012ba7af3ad0a1389363ccd9f.svg";
export { ForwardRef as ReactComponent };